/** Webpack (web): galeri modülü yerine güvenli saplama — asıl seçim `pickListingMedia` içinde `<input type="file">` ile. */
export async function launchImageLibrary(): Promise<{ didCancel?: boolean; errorCode?: string; assets?: undefined }> {
  return { didCancel: true };
}
